import { Loading, Toast } from "@xp-design/mobile";
import FontSetBox from "@/component/fontSetBox";
import FontSetBoxs from "@/component/fontSetBox/fontSetBoxNew";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  chartRankingInfoList,
  getInvitationMessage,
  individualLeaderboard,
  joinTheTeam,
  teamLeaderboard,
} from "./ajax";
import style from "./index.module.less";
import { getCurrentUid } from "@/api/common";
import OneTwoThreeBox from "./components/oneTwoThreeBox";
import FooterInfoBox from "./components/footerInfoBox";
import RankList from "./components/rankList";
import FullRankingPopup, {
  FullRankingPopupRef,
} from "./components/fullRankingPopup";
import { RightOutline } from "antd-mobile-icons";
import { useSearchParams } from "react-router-dom";
import { goToPageV2, debounce } from "@/utils/common";
import {
  ActivityData,
  UserActivityData,
  IndividualLeaderboard,
  ShareInfoData,
} from "./type";
import { getChannel, getBrowserEnv } from "@/utils/tools";
import { trackGdp } from "@/utils/gio-report";
import PopupCom from "@/component/popupCom";
import { enhancedSafeChainFind } from "../../utils";
import InViewWithCallback from "@/components/InViewWithCallback";
import ActivityDetailPopup, {
  ActivityDetailPopupRef,
} from "@/components/ActivityDetailPopup";
import PrizeRecordPopup, {
  PrizeRecordPopupRef,
} from "@/components/PrizeRecordPopup";
import ActivityDetailButton from "@/components/ActivityDetailButton";
import { teamMemberList } from "@/pages/par-marketing/myTeam/ajax";
import { ApiResponse } from "@/pages/par-marketing/detailPage/type";
import { processOssImage } from "@/utils/image";
import { getParamsFromHash, removeUrlParameters } from "@/utils/url";
type Props = {
  activityInfo: any;
  moduleJsonData: any; //
  navHeight: any;
};
let pageNo = 1;
let pageSize = 20;
const App = (props: Props) => {
  const { isXPApp } = getBrowserEnv();
  // const [searchParams] = useSearchParams();
  const PopupComRef = useRef<any>(null);
  // 活动详情弹窗引用
  const activityDetailPopupRef = useRef<ActivityDetailPopupRef>(null);
  // 中奖记录弹窗引用
  const prizeRecordPopupRef = useRef<PrizeRecordPopupRef>(null);
  const { moduleJsonData, navHeight } = props;
  const [teamConfigData, setTeamConfigData] = useState<any>(null);

  // 视图状态管理
  const [rankListInView, setRankListInView] = useState(false);
  const [footerInfoBoxInView, setFooterInfoBoxInView] = useState(false);
  const [footerHeight, setFooterHeight] = useState(150); // 默认150px，动态获取实际高度
  const footerRef = useRef<HTMLDivElement>(null);

  // 业务逻辑保持在原位置
  const shareUid = getParamsFromHash("shareUid");
  const teamCode = getParamsFromHash("teamCode");
  const shareType = getParamsFromHash("shareType");
  const isRanking = shareType === "ranking";

  // 使用 ResizeObserver 实时监听 FooterInfoBox 高度变化
  useEffect(() => {
    if (!footerRef.current) return;

    const updateFooterHeight = () => {
      if (footerRef.current) {
        const height = footerRef.current.offsetHeight;
        const newHeight = height > 0 ? height : 150;
        setFooterHeight((prevHeight) => {
          if (prevHeight !== newHeight) {
            console.log(
              "📏 FooterInfoBox 高度变化:",
              prevHeight,
              "->",
              newHeight,
            );
            return newHeight;
          }
          return prevHeight;
        });
      }
    };

    // 初始获取高度 - 延迟执行确保 DOM 已渲染
    const timer = setTimeout(updateFooterHeight, 100);

    // 使用 ResizeObserver 监听尺寸变化（推荐方式）
    let resizeObserver: ResizeObserver | null = null;
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        updateFooterHeight();
      });
      resizeObserver.observe(footerRef.current);
    } else {
      // 兜底方案：监听窗口大小变化
      window.addEventListener("resize", updateFooterHeight);
    }

    return () => {
      clearTimeout(timer);
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener("resize", updateFooterHeight);
      }
    };
  }, []); // 空依赖数组，只在组件挂载时设置监听器

  // 当数据变化时，重新检查高度（作为 ResizeObserver 的补充）
  useEffect(() => {
    const timer = setTimeout(() => {
      if (footerRef.current) {
        const height = footerRef.current.offsetHeight;
        const newHeight = height > 0 ? height : 150;
        setFooterHeight((prevHeight) => {
          if (prevHeight !== newHeight) {
            console.log(
              "🔄 数据变化导致高度更新:",
              prevHeight,
              "->",
              newHeight,
            );
            return newHeight;
          }
          return prevHeight;
        });
      }
    }, 200); // 延迟一下确保数据更新后 DOM 重新渲染

    return () => clearTimeout(timer);
  }, [moduleJsonData]); // 监听可能影响 FooterInfoBox 高度的数据

  // 计算是否应该显示固定底部的FooterInfoBox（业务逻辑保持在原位置）
  const shouldShowFixedFooter = rankListInView && !footerInfoBoxInView;
  const boxBackUrl = useMemo(
    //排行组件 背景图
    () => {
      const result = enhancedSafeChainFind(moduleJsonData.visual)
        ?.prizeSetting("bgSetting")
        ?.content("rankBg")?.val?.val;
      return result || moduleJsonData.visual?.prizeSetting[0]?.content[0]?.val;
    },
    [moduleJsonData],
  );
  const activityCode = useMemo(
    //活动详情
    () => {
      const result =
        enhancedSafeChainFind(moduleJsonData)?.base("reActivity")?.val?.valCode;
      return result || moduleJsonData.base[0]?.val?.valCode;
    },
    [moduleJsonData],
  );
  // 活动Tab显示全部的数据取值
  const rankingTypeData = useMemo(() => {
    return moduleJsonData?.rewardSet?.rankingType;
  }, [moduleJsonData]);

  // 判断是否显示全部Tab（业务逻辑保持在原位置）
  const tabIsAll = rankingTypeData == "1,2" || rankingTypeData == "2,1";
  // 页面大小相关的数据取值
  const personRankNumData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData?.rankImg)?.rankData(
      "personRankNum",
    )?.val?.val;
    return result || moduleJsonData?.rankImg?.rankData[2]?.val;
  }, [moduleJsonData]);

  const teamRankNumData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData?.rankImg)?.rankData(
      "teamRankNum",
    )?.val?.val;
    return result || moduleJsonData?.rankImg?.rankData[3]?.val;
  }, [moduleJsonData]);

  const rankNumData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData?.rankImg)?.rankData(
      "rankNum",
    )?.val?.val;
    return result || moduleJsonData?.rankImg?.rankData[1]?.val;
  }, [moduleJsonData]);

  const rankTypeData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData?.rankImg)?.rankData(
      "rankType",
    )?.val?.val;
    return result || moduleJsonData?.rankImg?.rankData[0]?.val;
  }, [moduleJsonData]);

  // 业务逻辑保持在原位置
  const personPageSize =
    (personRankNumData ? personRankNumData - 0 : null) ||
    moduleJsonData?.rankImg?.rankData[2]?.val - 0 ||
    20;
  const teamPageSize =
    (teamRankNumData ? teamRankNumData - 0 : null) ||
    moduleJsonData?.rankImg?.rankData[3]?.val - 0 ||
    20;
  const rankNumPageSize =
    rankNumData || moduleJsonData?.rankImg?.rankData[1]?.val;

  // 标题内容相关的useMemo
  const titleContent = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
      "title",
    )?.val?.val;
    return result || moduleJsonData?.visual?.visualData?.[1]?.val;
  }, [moduleJsonData]);

  const subTitleContent = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
      "subTitle",
    )?.val?.val;
    return result || moduleJsonData?.visual?.visualData?.[2]?.val;
  }, [moduleJsonData]);

  const showElement = useMemo(() => {
    const result =
      enhancedSafeChainFind(moduleJsonData.visual)?.visualData("showElement")
        ?.val?.val || [];
    return result;
  }, [moduleJsonData]);

  const showConfig = (key) => {
    const enums = {
      title: "1",
      subTitle: "1",
      rankDetails: "2",
      rankReward: "3",
    };
    if (isNewBigRanking && showElement) {
      return showElement.includes(enums[key]);
    }
    return true;
  };

  // 样式数据相关的useMemo
  const activityTitleStyleData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("activityTitle")?.val?.styleData;
    return (
      result ||
      moduleJsonData?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.[0]
        ?.styleData
    );
  }, [moduleJsonData]);

  const activitySubTitleStyleData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("activitySubTitle")?.val?.styleData;
    return (
      result ||
      moduleJsonData?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.[1]
        ?.styleData
    );
  }, [moduleJsonData]);

  console.log("%c Line:34 🥖 moduleJsonData", "color:#b03734", moduleJsonData);
  // 是否关闭首页内容
  const [showHomeFlag, setShowHomeFlag] = useState(true);
  const [prizeMaskShow, setPrizeMaskShow] = useState(false);
  const goSeeAll = () => {
    localStorage.setItem(
      `activityInfo${props.activityInfo.moduleId}`,
      JSON.stringify(props.activityInfo),
    );
    localStorage.setItem(
      `moduleJsonData${props.activityInfo.moduleId}`,
      JSON.stringify(moduleJsonData),
    );
    goToPageV2({
      hash: `/rankingDetail?moduleId=${props.activityInfo.moduleId}&shareUid=${shareUid}&teamCode=${teamCode}&shareType=${shareType}`,
    });
  };
  //我的奖品
  const myAward = () => {
    const activityInfo = props.activityInfo;
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: visualStyleTypeName,
      status: rankObj.activityStatusCn || "",
      clickLocation: "中奖记录",
    });
    // 使用弹窗显示中奖记录
    prizeRecordPopupRef.current?.show(activityCode);
  };
  const hdxq = useMemo(
    //活动详情
    () => {
      const result = enhancedSafeChainFind(moduleJsonData.visual)
        ?.prizeSetting("btnSetting")
        ?.content("rankDetails")?.val?.val;
      return (
        result || moduleJsonData?.visual?.prizeSetting?.[1]?.content?.[2]?.val
      );
    },
    [moduleJsonData],
  );
  // 排名奖励
  const pmjlPopUpRef = useRef<any>(null);
  // 完整榜单弹窗
  const fullRankingPopupRef = useRef<FullRankingPopupRef>(null);
  const visualStyleTypeName = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
      "visualStyle",
    )?.val?.typeName;
    return result || moduleJsonData?.visual?.visualData?.[0]?.typeName;
  }, [moduleJsonData]);

  const isNewBigRanking = visualStyleTypeName == "大排行榜（新）";
  const isBigRanking = visualStyleTypeName == "大活动排行榜";
  const pmjl = useMemo(
    // 排名奖励按钮图片
    () => {
      const result = enhancedSafeChainFind(moduleJsonData.visual)
        ?.prizeSetting("btnSetting")
        ?.content("rankReward")?.val?.val;
      return (
        result || moduleJsonData?.visual?.prizeSetting?.[1]?.content?.[3]?.val
      );
    },
    [moduleJsonData],
  );
  const pmjlBackUrl = useMemo(
    //排名奖励 背景图
    () => {
      const result = enhancedSafeChainFind(moduleJsonData.visual)
        ?.prizeSetting("popSetting")
        ?.content("rankRewardPop")?.val?.val;
      return (
        result || moduleJsonData?.visual?.prizeSetting?.[2]?.content?.[0]?.val
      );
    },
    [moduleJsonData],
  );
  const rankMyTab = useMemo(
    //我的排名Tab背景图
    () => {
      const result = enhancedSafeChainFind(moduleJsonData.visual)
        ?.prizeSetting("bgSetting")
        ?.content("rankMyTab")?.val?.val;
      return (
        result || moduleJsonData?.visual?.prizeSetting?.[2]?.content?.[0]?.val
      );
    },
    [moduleJsonData],
  );
  const rankTeamTab = useMemo(
    //组队排名Tab背景图
    () => {
      const result = enhancedSafeChainFind(moduleJsonData.visual)
        ?.prizeSetting("bgSetting")
        ?.content("rankTeamTab")?.val?.val;
      return (
        result || moduleJsonData?.visual?.prizeSetting?.[2]?.content?.[0]?.val
      );
    },
    [moduleJsonData],
  );
  // 加入队伍背景图
  const PopupComBacUrl = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("popSetting")
      ?.content("rankJoinTeam")?.val?.val;
    return (
      result || moduleJsonData?.visual?.prizeSetting?.[2]?.content?.[2]?.val
    );
  }, [moduleJsonData]);
  const rankListBg = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("bgSetting")
      ?.content("rankListBg")?.val?.val;
    return result || "";
  }, [moduleJsonData]);
  // 排名奖励弹窗中的活动值名称数据取值
  const activityValueNameData = useMemo(() => {
    const result =
      enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
        "activityValueName",
      )?.val?.val || "";
    return result || moduleJsonData?.visual?.visualData?.[3]?.val;
  }, [moduleJsonData]);

  // 更新时间样式数据取值
  const updateTimeStyleData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("rankUpdateTime")?.val?.styleData;
    return (
      result ||
      moduleJsonData?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.[4]
        ?.styleData
    );
  }, [moduleJsonData]);

  const [pmIndex, setPmIndex] = useState(0);
  const [pmjlData, setPmjlData] = useState<any[]>([]);
  const pmTabChange = (index: number) => {
    if (pmIndex == index) {
      return;
    }
    setPmjlData([]);
    setPmIndex(index);
    setTimeout(() => {
      setPmjlData(moduleJsonData?.rewardSet?.rewardData?.[index]?.data || []);
    }, 10);
  };
  function truncateText(selector: string, lines: number) {
    const element = document.querySelector(selector);
    const lineHeight = 1.2; // 根据实际行高调整
    const maxHeight = lineHeight * lines;

    if (element && element.scrollHeight && element.scrollHeight > maxHeight) {
      const text = element.textContent;
      let truncatedText = text;

      while (element.scrollHeight > maxHeight && truncatedText) {
        truncatedText = truncatedText.slice(0, -1);
        element.textContent = truncatedText + "...";
      }
    }
  }
  // 排名奖励弹窗事件
  const pmjlEvent = debounce(() => {
    document.body.style.pointerEvents = "none";
    setTimeout(() => {
      document.body.style.pointerEvents = "";
    }, 500);
    setPrizeMaskShow(true);
    pmjlPopUpRef.current.onOpen();
    truncateText("#text-container", 2);
    const activityInfo = props.activityInfo;
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: visualStyleTypeName,
      status: rankObj.activityStatusCn || "",
      clickLocation: "排名奖励",
    });
  }, 500);

  // 完整榜单弹窗事件
  const showFullRankingEvent = debounce(() => {
    document.body.style.pointerEvents = "none";
    setTimeout(() => {
      document.body.style.pointerEvents = "";
    }, 500);

    fullRankingPopupRef.current?.show();

    const activityInfo = props.activityInfo;
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: visualStyleTypeName,
      status: rankObj.activityStatusCn || "",
      clickLocation: "查看完整榜单",
    });
  }, 500);
  const onCloseCallBack = async () => {
    setTimeout(() => {
      setPrizeMaskShow(false);
    }, 500);
  };
  //加入队伍
  const [sharePeoInfo, setSharePeoInfo] = useState<ShareInfoData>({});
  const getSharePeo = async () => {
    try {
      Loading.show("加载中...");
      const uid = await getCurrentUid();
      const res = await getInvitationMessage({
        uid,
        activityCode,
        pageCode: props.activityInfo.pageCode,
        shareUid,
        teamCode,
      });
      console.log("%c Line:164 🍊 res", "color:#fca650", res);
      if (res.code == 200) {
        setSharePeoInfo(res.data);
        // 分享人信息查询
        PopupComRef.current?.onOpen();
      } else {
        // 查询人分享人信息失败 删除url分享人信息
        handleRemoveParam();
        Toast.show({
          content: res.msg,
        });
      }
    } catch (error: any) {
    } finally {
      Loading.hide();
    }
  };
  useEffect(() => {
    if (shareUid) {
      if (isRanking) {
        getSharePeo();
      }
    }
  }, [shareUid]);
  const onCallback = async () => {
    try {
      Loading.show("加载中...");
      const uid = await getCurrentUid();
      //加入队伍回调
      const res = await joinTheTeam({
        uid,
        activityCode,
        pageCode: props.activityInfo.pageCode,
        shareUid,
        teamCode,
      });
      console.log("%c Line:93 🥥 res", "color:#ea7e5c", res);
      if (res.code == 200 && res.data) {
        Toast.show({
          content: "加入成功",
        });
      } else {
        Toast.show({
          content: res.msg,
        });
      }
    } catch (error: any) {
    } finally {
      Loading.hide();
      handleRemoveParam();
      getData();
    }
    const activityInfo = props.activityInfo;
    trackGdp("P20217", "B002", {
      // 点击埋点
      trackName: "充电_排行榜_我的队伍_按钮点击",
      origin: getChannel(),
      activityId: activityInfo.connectedActivitiesId,
      clickLocation: "立即加入",
    });
  };
  const handleRemoveParam = () => {
    // const currentParams = new URLSearchParams(searchParams);
    // currentParams.delete("shareUid"); // 删除参数
    // currentParams.delete("shareType"); // 删除参数
    // currentParams.delete("teamCode"); // 删除参数
    // const newSearchParams = currentParams.toString();
    const url = removeUrlParameters(window.location.href, [
      "shareUid",
      "shareType",
      "teamCode",
    ]);
    window.history.replaceState({}, document.title, url);
  };
  // 页面信息
  const [rankObj, setRankObj] = useState<ActivityData>({ rankUpdateTime: "" });
  async function getData() {
    try {
      Loading.show("加载中...");
      // 获取样式配置页面配置  type类型 打榜 busi-ranking
      const uid = await getCurrentUid();
      // 首页详情信息
      const data = (await chartRankingInfoList({
        uid,
        activityCode,
      })) as ActivityData;
      setRankObj(data || {});

      const { records } = (await teamMemberList({
        uid,
        activityCode,
      })) as ApiResponse;
      setTeamConfigData(records && records[0] ? records[0] : {});
    } catch (error) {
      console.log("%c Line:134 🥥 error", "color:#7f2b82", error);
    } finally {
      Loading.hide();
    }
  }

  // 个人排行数据
  // 前三名数据
  const [topThreePersonal, setTopThreePersonal] = useState<UserActivityData[]>(
    [],
  );
  // 从第四名开始的数据
  const [rankDataList, setRankDataList] = useState<UserActivityData[]>([]);
  const [total, setTotal] = useState(0);
  const [isHaveData, setIsHaveData] = useState(true);
  const [loading, setLoading] = useState(false);
  const getRankingListData = async (flag: boolean, pageIndex?: number) => {
    try {
      setLoading(true);
      Loading.show("加载中...");
      const uid = await getCurrentUid();
      const leaderboardFunction = flag
        ? individualLeaderboard
        : teamLeaderboard;
      // 个人排行信息
      const { records, total } = (await leaderboardFunction({
        pageNo: pageIndex || pageNo,
        pageSize,
        uid,
        activityCode,
      })) as IndividualLeaderboard;
      pageNo++;
      // 数据 从四名开始 才有列表显示
      if (total > 3) {
        setTotal(total - 3);
      } else {
        setTotal(total);
      }
      if (total == 0) {
        // 当数据为空时
        setIsHaveData(false);
      }
      setTopThreePersonal((prevArray) => {
        if (prevArray.length == 0 && records.length != 0) {
          // 第一次请求 或者切换个人或者排队模式的时候 刷新
          let rearranged: UserActivityData[] = [];
          if (records.length == 1) {
            rearranged = [records[0]];
          } else if (records.length == 2) {
            rearranged = [records[0], records[1]];
          } else {
            const topThree = records.splice(0, 3);
            rearranged = [topThree[1], topThree[0], topThree[2]];
          }
          return rearranged;
        } else if (prevArray.length == 1) {
          return [...prevArray, records[0]];
        } else if (prevArray.length == 2) {
          const topThree = records.splice(0, 1);
          return [prevArray[1], prevArray[0], topThree[0]];
        } else {
          return prevArray;
        }
      });
      const num = (pageNo - 1) * pageSize;
      if (num > 3 && total > 3) {
        // 一次请求的数量和 数据总量都大于3的时候才开始 设置从第4名开始的数据列表
        setRankDataList((prevArray) => [...prevArray, ...records]);
      }
      if (total <= 3 && (pageNo - 1) * pageSize >= total) {
        setIsHaveData(false);
      }
    } catch (error) {
      console.log("%c Line:189 🍯 error", "color:#b03734", error);
    } finally {
      Loading.hide();
      setLoading(false);
    }
  };
  // 是否是个人排队模式
  const [isPeoModel, setIsPeoModel] = useState(true);
  const maxPageSize = isNewBigRanking
    ? isPeoModel
      ? personPageSize
      : teamPageSize
    : total;
  // 当 rankObj 或 isPeoModel 变化时，重新检查 FooterInfoBox 高度
  useEffect(() => {
    const timer = setTimeout(() => {
      if (footerRef.current) {
        const height = footerRef.current.offsetHeight;
        const newHeight = height > 0 ? height : 150;
        setFooterHeight((prevHeight) => {
          if (prevHeight !== newHeight) {
            console.log(
              "🔄 数据变化导致高度更新 (rankObj/isPeoModel):",
              prevHeight,
              "->",
              newHeight,
            );
            return newHeight;
          }
          return prevHeight;
        });
      }
    }, 300); // 延迟一下确保数据更新后 DOM 重新渲染

    return () => clearTimeout(timer);
  }, [rankObj, isPeoModel]); // 监听 rankObj 和 isPeoModel 变化
  const changeModel = (flag: boolean, isInit = false) => {
    console.log("rankObj-------", rankObj);
    if (isPeoModel != flag || isInit) {
      pageNo = 1;
      setTopThreePersonal([]);
      setRankDataList([]);
      setIsPeoModel(flag);
      getRankingListData(flag, pageNo);
      const activityInfo = props.activityInfo;
      if (!isInit) {
        trackGdp("P20189", "B004", {
          trackName: "充电_营销专题页_组件点击",
          origin: getChannel(),
          userType: "",
          versionId: activityInfo.versionCode,
          pageId: activityInfo.pageCode,
          ComponentCode: activityInfo.moduleId,
          description: activityInfo.moduleRemark,
          type: activityInfo.moduleType,
          activityId: activityInfo.connectedActivitiesId,
          comp_style: visualStyleTypeName,
          status: rankObj.activityStatusCn || "",
          clickLocation: flag ? "个人排名" : "组队排名",
        });
      }
      setIsHaveData(true);
    }
  };

  // 刷新首页数据
  const onRefresh = (flag: boolean) => {
    getData();
    pageNo = 1;
    setTopThreePersonal([]);
    setRankDataList([]);
    setIsPeoModel(flag);
    getRankingListData(flag, pageNo);
  };
  useEffect(() => {
    // 个人
    if (isPeoModel) {
      pageSize =
        isNewBigRanking || isBigRanking ? personPageSize : rankNumPageSize;
    } else {
      // 组队
      pageSize =
        isNewBigRanking || isBigRanking ? teamPageSize : rankNumPageSize;
    }
  }, [
    isPeoModel,
    isNewBigRanking,
    isBigRanking,
    personPageSize,
    teamPageSize,
    rankNumPageSize,
  ]);
  useEffect(() => {
    if (isBigRanking || isNewBigRanking) {
      // 如果是 大活动排行榜 不显示查看完整榜单
      setShowHomeFlag(false);
      localStorage.setItem(
        `isOneRankingOpen${props.activityInfo.moduleId}`,
        "1",
      );
    }
    pageNo = 1;
    getData();
    // 打开过首页回退不再显示首页
    const isOneRankingOpen =
      localStorage.getItem(`isOneRankingOpen${props.activityInfo.moduleId}`) ||
      "";
    if (isOneRankingOpen == "1") {
      setShowHomeFlag(false);
      // 区分 首次加载是 个人排行 还是 组队排行
      const isTeam = moduleJsonData?.rewardSet?.rankingType == "2";
      // 判断 是否是只有队伍  如果是显示个人和显示全部的时候 都默认加载个人排行 需要传入 true
      changeModel(!isTeam, true);
    } else {
      // 小榜 外显逻辑
      pageSize = rankNumPageSize;
      const isTeam = rankTypeData == "组队";
      changeModel(!isTeam, true);
    }
    setPmIndex(0);
    setPmjlData(moduleJsonData.rewardSet.rewardData[0]?.data || []);
  }, [moduleJsonData]);
  return (
    <div
      className={style["pageBox"]}
      style={{
        backgroundImage: `url(${processOssImage(boxBackUrl)})`,
      }}
    >
      {!showHomeFlag && showConfig("rankDetails") && (
        <ActivityDetailButton
          mode="description"
          activityInfo={props.activityInfo}
          data={rankObj.activityDescribe || ""}
          activityDetailPopupRef={activityDetailPopupRef}
          buttonImage={hdxq}
          componentType="ranking"
          className={style["hdxq"]}
          activityId={props.activityInfo.connectedActivitiesId}
        />
      )}
      {!showHomeFlag && showConfig("rankReward") && (
        <img
          src={processOssImage(pmjl)}
          className={style["pmjl"]}
          onClick={pmjlEvent}
        />
      )}
      <div className={style["titileBox"]}>
        {showConfig("title") && (
          <div className={style["bigTitile"]}>
            <FontSetBoxs
              content={titleContent}
              styleData={activityTitleStyleData}
            />
          </div>
        )}
        {showHomeFlag ? (
          <div className={style["seeAll"]} onClick={goSeeAll}>
            点击报名参与打榜
            <RightOutline />
          </div>
        ) : (
          <div className={style["subTitleWrapper"]}>
            {showConfig("title") && (
              <FontSetBox
                content={subTitleContent}
                styleData={activitySubTitleStyleData}
              />
            )}
          </div>
        )}
      </div>
      <div className={`${isNewBigRanking && style["rankImgBg"]}`}>
        {!showHomeFlag &&
          tabIsAll &&
          (isNewBigRanking ? (
            <div
              className={style["tabContentBox"]}
              style={{
                backgroundImage: `url(${processOssImage(isPeoModel ? rankMyTab : rankTeamTab)})`,
              }}
            >
              <>
                <div
                  className={style["tabBoxLeft"]}
                  onClick={() => changeModel(true)}
                />
                <div
                  className={style["tabBoxRight"]}
                  onClick={() => changeModel(false)}
                />
              </>
            </div>
          ) : (
            <div className={style["tabBox"]}>
              <>
                <div
                  className={isPeoModel ? style["tabBoxActive"] : ""}
                  onClick={() => changeModel(true)}
                >
                  个人排行
                </div>
                <div
                  className={!isPeoModel ? style["tabBoxActive"] : ""}
                  onClick={() => changeModel(false)}
                >
                  组队排行
                </div>
              </>
            </div>
          ))}
        <div
          className={style["rankBox"]}
          style={{
            backgroundImage: `url(${isNewBigRanking ? processOssImage(rankListBg) : ""})`,
            maxHeight: `${(isNewBigRanking ? 600 : 500) - (isXPApp ? navHeight : 0)}px`,
          }}
        >
          {!showHomeFlag && (
            <div className={style["timeBox"]}>
              <FontSetBox
                content={`${rankObj.activityStatus === "4" ? "" : "排行更新时间："}${rankObj.rankUpdateTime}`}
                styleData={updateTimeStyleData}
              />
              <div onClick={() => myAward()}>
                我的奖品
                <RightOutline />
              </div>
            </div>
          )}
          <OneTwoThreeBox
            list={topThreePersonal}
            moduleJsonData={moduleJsonData}
            isPeoModel={isPeoModel}
          />
          {!showHomeFlag && (
            <InViewWithCallback
              threshold={0.1}
              onVisibilityChange={(inView) => {
                console.log("🔵 RankList 视图状态变化:", inView);
                setRankListInView(inView);
              }}
            >
              <RankList
                showNum={(pageNo - 1) * pageSize}
                isShowMoreBtn={
                  isHaveData &&
                  total > rankDataList.length + 3 &&
                  maxPageSize > rankDataList.length + 3 &&
                  pageNo - 1 != 100 &&
                  !loading
                }
                isNotMore={
                  (total == rankDataList.length + 3 && !loading) ||
                  (pageNo - 1 == 100 && !loading) ||
                  !isHaveData
                }
                list={rankDataList}
                moduleJsonData={moduleJsonData}
                isPeoModel={isPeoModel}
                getMore={getRankingListData}
                isNewBigRanking={isNewBigRanking}
                onShowFullRanking={showFullRankingEvent}
                isInPopup={false}
                total={total}
              />
            </InViewWithCallback>
          )}
        </div>
      </div>
      {!showHomeFlag && (
        <InViewWithCallback
          threshold={0}
          rootMargin={`0px 0px -${footerHeight * 1}px 0px`}
          onVisibilityChange={(inView) => {
            console.log("setFooterInfoBoxInView", inView);
            setFooterInfoBoxInView(inView);
          }}
        >
          <div ref={footerRef}>
            <FooterInfoBox
              onRefresh={onRefresh}
              activityInfo={props.activityInfo}
              infoObj={rankObj}
              moduleJsonData={moduleJsonData}
              isPeoModel={isPeoModel}
              teamConfigData={teamConfigData}
            />
          </div>
        </InViewWithCallback>
      )}
      <PopupCom
        ref={PopupComRef}
        bacUrl={PopupComBacUrl}
        onCallback={onCallback}
        title="加入队伍"
        btnStr="立即加入"
        children={
          <div className={style["sharePeoInfo"]}>
            <div className={style["peoName"]}>
              用户{sharePeoInfo?.shareUserName}邀请您加入队伍
            </div>
            <div className={style["teamName"]}>{sharePeoInfo?.teamName}</div>
          </div>
        }
      />
      <PopupCom
        ref={pmjlPopUpRef}
        height="70%"
        bacUrl={pmjlBackUrl}
        onCallback={onCallback}
        onCloseCallBack={onCloseCallBack}
        children={
          <div className={style["pmjlDataBox"]}>
            <div className={style["title"]}>排名奖励</div>
            {moduleJsonData.rewardSet.rewardData.length == 2 && (
              <div className={style["tabBox"]}>
                <div
                  className={pmIndex == 0 ? style["tabBoxActive"] : ""}
                  onClick={() => pmTabChange(0)}
                >
                  个人奖励
                </div>
                <div
                  className={pmIndex == 1 ? style["tabBoxActive"] : ""}
                  onClick={() => pmTabChange(1)}
                >
                  组队奖励
                </div>
              </div>
            )}
            <div className={style["pmjlDataList"]}>
              {pmjlData?.map((item: any, i: number) => (
                <div className={style["pmjlData"]} key={`pmjlData${i}`}>
                  <div className={style["pmjlData_title"]}>
                    <div className={style["rank"]}>
                      {item.rankBegin}-{item.rankEnd}名
                    </div>
                    {item.prizeCill != "0" && (
                      <div className={style["describe"]}>
                        {pmIndex == 0 ? "个人" : "组队累计"}
                        {activityValueNameData}须达到
                        {item.prizeCill}及以上能获得该奖励
                      </div>
                    )}
                  </div>
                  <div className={style["prizeList"]}>
                    {item.prizeList?.map((n: any, j: number) =>
                      !isNewBigRanking ? (
                        <div
                          className={style["prizeList_data"]}
                          key={`prizeList_data${j}`}
                        >
                          <div className={style["prizeList_img"]}>
                            <img
                              src={processOssImage(n.val)}
                              alt="找不到图片"
                            />
                          </div>
                          <div
                            className={style["prizeList_font"]}
                            id="text-container"
                          >
                            {n.productName} x {n.singleDistributionCount}
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className={style["prizeList_data_new"]}>
                            <img
                              src={processOssImage(n.val)}
                              alt="找不到图片"
                            />
                          </div>
                        </>
                      ),
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        }
      />
      {prizeMaskShow && <div className={style.prizeMask}></div>}

      {/* 完整榜单弹窗组件 */}
      <FullRankingPopup
        ref={fullRankingPopupRef}
        moduleJsonData={moduleJsonData}
        activityCode={activityCode}
        boxBackUrl={boxBackUrl}
        isPeoModel={isPeoModel}
        rankObj={rankObj}
        maxPageSize={maxPageSize}
        isNewBigRanking={isNewBigRanking}
        activityInfo={props.activityInfo}
      />

      {/* 固定在视窗底部的FooterInfoBox - 仅在RankList可见但FooterInfoBox不可见时显示 */}
      {isNewBigRanking && !showHomeFlag && (
        <div
          className={style["fixedFooter"]}
          style={{ visibility: shouldShowFixedFooter ? "visible" : "hidden" }}
        >
          <FooterInfoBox
            onRefresh={onRefresh}
            activityInfo={props.activityInfo}
            infoObj={rankObj}
            moduleJsonData={moduleJsonData}
            isPeoModel={isPeoModel}
            teamConfigData={teamConfigData}
          />
        </div>
      )}

      {/* 活动详情弹窗组件 */}
      <ActivityDetailPopup ref={activityDetailPopupRef} />

      {/* 中奖记录弹窗组件 */}
      <PrizeRecordPopup
        ref={prizeRecordPopupRef}
        moduleJsonData={moduleJsonData}
        activityInfo={props.activityInfo}
      />
    </div>
  );
};

export default App;
